import {PhysicalMode, Feature} from './graphql-type.enum';
import {OsmLevel} from './network.enum';
import Translate from '../../services/translate';

export const TabsItineraryTransport = [
    {
        id: 'ALL',
        text: Translate.print('itinerary.tabs.all'),
        icon: null,
        active: true,
    }, {
        id: PhysicalMode.Bus,
        text: Translate.print('itinerary.tabs.bus'),
        icon: Theme.themeURL + '/assets/dist/images/type/BUS.svg',
        active: false,
    }, {
        id: PhysicalMode.Tramway,
        text: Translate.print('itinerary.tabs.tram'),
        icon: Theme.themeURL + '/assets/dist/images/type/TRAMWAY.svg',
        active: false,
    }, {
        id: PhysicalMode.Metro,
        text: Translate.print('itinerary.tabs.metro'),
        icon: Theme.themeURL + '/assets/dist/images/type/METRO.svg',
        active: false,
    }, {
        id: Feature.Bss,
        text: Translate.print('itinerary.tabs.bike'),
        icon: Theme.themeURL + '/assets/dist/images/type/VELO.svg',
        active: false,
    }
];

export const TabsTypeNetworks = [
    {
        id: OsmLevel.URBAIN,
        text: 'network.urbain',
        icon: null,
        active: true
    }, {
        id: OsmLevel.DEPT,
        text: 'network.department',
        icon: null,
        active: false
    }, {
        id: OsmLevel.REGION,
        text: 'network.regional',
        icon: null,
        active: false
    }
];

export const TabsFilterNetworks = [
    {
        id: 'distance',
        text: 'network.distance',
        icon: null,
        active: false,
        disabled: false,
    }, {
        id: 'name',
        text: 'network.name',
        icon: null,
        active: true,
        disabled: false,
    }
];